import React from "react";
import Select from "../Select/Select";

import classes from "./Input.module.scss";

// ==> TODO ==> Eliminare questo component e accorparlo a FormInput.js
const input = props => {
  let inputElement = null;
  const inputClasses = `${classes.inputElement} ${props.inputClasses}`;

  const submit = (e, stateKey, value) => {
    if (props.submitForm) {
      e.preventDefault();
      props.submitForm(stateKey, value);
    }
  };

  const generalConf = {
    ...props.elementConfig,
    value: props.comingsoon ? props.comingsoon : props.value,
    onChange: e =>
      props.changed ? props.changed(props.stateKey, e.target.value) : null,
    onBlur: e =>
      props.blur ? props.blur(props.stateKey, e.target.value) : null,
    onKeyDown: e =>
      e.which === 13 ? submit(e, props.stateKey, e.target.value) : null,
    className: `${inputClasses} input`,
    disabled: props.disabled ? true : false,
    defaultValue: props.defaultValue ? props.defaultValue : undefined
  };

  if (props.invalid && props.shouldValidate && props.touched) {
    inputClasses.push(classes.Invalid);
  }

  let ref;

  switch (props.elementType) {
    case "input":
      ref = props.refer ? { ref: props.refer } : null;
      inputElement = (
        <input
          {...ref}
          {...generalConf}
          type={props.inputType || "text"}
          placeholder={props.placeholder}
        />
      );
      break;
    case "textarea":
      inputElement = (
        <textarea {...generalConf} placeholder={props.placeholder} />
      );
      break;
    case "select":
      ref = props.refer ? { refer: props.refer } : null;
      inputElement = (
        <Select
          {...ref}
          {...generalConf}
          onChange={props.changed}
          placeholder={props.placeholder}
        />
      );
      break;
    default:
      inputElement = <input {...generalConf} placeholder={props.placeholder} />;
  }

  return (
    <div className={`${classes.inputWrapper} ${props.className} ${props.disabled ? props.disabledClass : ""}`}>
      {props.label ? (
        <label
          className={`${classes.label} ${
            props.error ? classes.error : ""
          }`}
        >
          {props.label}
        </label>
      ) : null}
      <div
        className={`
        flexContainer justifyStart 
        ${classes.inputContainer} 
        ${props.containerClasses} 
        ${props.error ? classes.error : ""} 
        `}
      >
        {props.icon ? <span className={classes.icon}>{props.icon}</span> : null}
        {inputElement}
      </div>
    </div>
  );
};

export default input;
